

import appsettings from '@/store/app-settings'
import {axiosGet, axiosPost}  from '@/store/api/axiosUtils.js'

const uploadFile = (params) => {
    return axiosPost(appsettings.ocpbComplaintAPIUrl + 'api/FileUpload/Upload', params)
}

const uploadFileWithType = (params) => {
    return axiosPost(appsettings.ocpbComplaintAPIUrl + 'api/FileUpload/UploadWithType', params)
}

const DeleteFile = (params,userId) => {
    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/FileUpload/DeleteFile?id='+ params+'&userId='+userId)
}

export {uploadFile,uploadFileWithType,DeleteFile}